import be from "./be-lang.json";

export const postalConfig = {
  be
};
